'use client'

import { useGetPromotionsInfoQuery } from '@/shared/api-rtk/api-list/cartApi'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'

export const PromoCards = ({ productPrice }) => {
    const { data, isLoading, isError, isSuccess } = useGetPromotionsInfoQuery()
    const { userInfo, userAuth } = useGetIsAuthUser()

    if (isLoading) return
    if (isError) return

    return (
        <div className={`PromoCards ${productPrice <= 0 ? ' price-low' : ''}`}>
            {/* {(!userAuth ||
                (userAuth && Number(userInfo?.customerGroupId) !== 2)) && (
                <div className={'item-card'}>
                    <span>
                        Бесплатная доставка от <b>4000₽</b>
                    </span>
                </div>
            )}
            {data?.xPlusOne?.status &&
                (Number(data.xPlusOne.info.customer_group_id) === 0 ||
                    Number(data.xPlusOne.info.customer_group_id) ===
                        Number(userInfo?.customerGroupId)) && (
                    <div className={'item-card'}>
                        <span>
                            Акция <b>{data.xPlusOne.info.product_count} + 1</b>
                        </span>
                    </div>
                )}
            {data?.discount?.status &&
                (Number(data.discount.info.customer_group_id) === 0 ||
                    Number(data.discount.info.customer_group_id) ===
                        Number(userInfo?.customerGroupId)) && (
                    <div className={'item-card'}>
                        <span>
                            Скидка <b>{data.discount.info.percent}%</b> при
                            заказе на сумму от{' '}
                            <b>{data.discount.info.total}₽</b>
                        </span>
                    </div>
                )}
            {data?.presents?.status && (
                <div className={'item-card'}>
                    <span>
                        Подарок при заказе на сумму от{' '}
                        <b>{data.presents.info.total}₽</b>
                    </span>
                </div>
            )} */}
            
            <div className={'item-card'}>
                <span>
                    Бесплатная доставка от <b>3000₽</b>
                </span>
            </div>
            <div className={'item-card'}>
                <span>
                    Подарок при заказе на сумму от{' '}
                    <b>4500₽</b>
                </span>
            </div>
        </div>
    )
}
